import { combineReducers, configureStore } from "@reduxjs/toolkit";
import branchSlice from "./branchSlice";
import themeConfigSlice from "./themeConfigSlice";

const rootReducer = combineReducers({
  themeConfig: themeConfigSlice,
  branch: branchSlice,
});
export default configureStore({
  reducer: rootReducer,
});

export type IRootState = ReturnType<typeof rootReducer>;
